import { render, staticRenderFns } from "./PosTotpToken.vue?vue&type=template&id=856b27fc"
import script from "./PosTotpToken.vue?vue&type=script&lang=js"
export * from "./PosTotpToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports